import React from 'react';
import CompanyInfoCards2 from './CompanyInfoCards2';
import '../../../index.css';

const About2 = () => {
  return (
    <main className="mt-[20px] min-h-screen bg-white"> {/* Altura fija para compensar el navbar */}
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl font-bold mb-6 text-gray-900">Sobre Nosotros</h1>
          <p className="text-lg mb-8 text-gray-700">
                                                              <>
                                                              </><>
                                                              </>
          </p>
          
          <CompanyInfoCards2 />
        </div>
      </div>
    </main>
  );
};

export default About2;